import axios from 'axios';

const client = axios.create({
    baseURL: 'https://smilemagazine1.wpcomstaging.com/wp-json/wp/v2',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    timeout: 15000
})

export default client;